module.exports = __webpack_public_path__ + "static/media/innovator-feature-second.000d7c05.jpg";